module.exports = __webpack_public_path__ + "media/styles/images/png/circle-ex-red-dark-on-white-3a656fd285e8b073989dc16399968772.png";